import React, { useState } from 'react'
import { Spin } from 'antd'

import CompanyEmptyState from './sections/CompanyEmptyState'
import CompanySetupForm from './sections/CompanySetup';
import { useGetCompanyQuery } from '@/services/api/company/companyApi';
import ModuleLoader from '@/components/UI/Loader/ModuleLoader';

const CompanySetup = () => {
  const [showSetup, setShowSetup] = useState(false);
  const {data:CompanyData, isLoading} = useGetCompanyQuery();
  
  const handleAddCompany = () => {
    setShowSetup(true);
  }
  
  const hasCompany = CompanyData?.length > 0;
  const companyInfo = CompanyData ? CompanyData[0]: null;
  
  // Show loading spinner while data is being fetched
  if (isLoading) {
    return (
      <ModuleLoader/>
      // <div className="flex justify-center items-center min-h-[400px]">
      //   <Spin size="large" />
      // </div>
    );
  }
  
  // Show setup form if company exists OR if user clicked add button
  if (hasCompany || showSetup) {
    // If user clicked add button (no existing company), start with General Info tab (index 0)
    // If company exists, start with General Info tab (index 0) as well
    return <CompanySetupForm data={companyInfo} initialTab={0} />;
  }
  
  // Show empty state only when no company data and not loading
  return <CompanyEmptyState handleAddCompany={handleAddCompany} />;
}

export default CompanySetup